import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SetPageTitle } from '../../utilities/TitleHelper';


const Error404 = () => {
  const { t } = useTranslation();

  useEffect(() => {
    SetPageTitle("404");
  }, [])

  return (
    <div className="row flex-center justify-content-center min-vh-100 py-6 text-center">
      <div className="col-sm-10 col-md-8 col-lg-6 col-xxl-5">

        <h1 className="mt-5" style={{ fontSize: 120, color: 'lightgray' }}>{t('404:heading')}</h1>

        <div className="card" id="crd404">
          <div className="card-body p-4 p-sm-5">
            <div className="fw-black lh-1 text-300 fs-error">404</div>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">{t('404:subHeading')}</p>
            <hr />
            <p>{t('404:msgText')}</p>
            <p><Link to="/"><button className="btn btn-primary">{t('error:btnReturnHome')}</button></Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;